import { Flex, Text } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal.js';
import { ISubmissionFileSet } from '@publishing-engine/domain/models/submission';
import { FormFieldFiguresAndTables } from '@publishing-engine/domain/types/article.js';
import { FiguresAndTablesDisplay } from './FiguresAndTableDisplay.js';
import { FiguresAndTablesEmptyState } from './FiguresAndTableEmptyState.js';

interface Props {
  value?: ISubmissionFileSet['FiguresAndTables'];
  previousValue?: ISubmissionFileSet['FiguresAndTables'];
  onClose: () => void;
  config: Omit<FormFieldFiguresAndTables, 'component'>;
}

export const FiguresAndTablesDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const label = config.params.labels.main;
  const hasPrevious = !!previousValue?.exists;
  const hasCurrent = !!value?.exists;

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">
            {config.params.labels.section.title}
          </Text>
          <Text>{previousValue?.exists ? 'Yes' : 'No'}</Text>
          <Text textStyle="headingItem">{label} </Text>
          {!hasPrevious ? (
            <FiguresAndTablesEmptyState fieldLabels={config.params.labels} />
          ) : (
            <FiguresAndTablesDisplay
              value={previousValue.value}
              fieldConfig={config}
            />
          )}
        </Flex>
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">
            {config.params.labels.section.title}
          </Text>
          <Text>{value?.exists ? 'Yes' : 'No'}</Text>
          <Text textStyle="headingItem">{label} </Text>
          {!hasCurrent ? (
            <FiguresAndTablesEmptyState fieldLabels={config.params.labels} />
          ) : (
            <FiguresAndTablesDisplay value={value.value} fieldConfig={config} />
          )}
        </Flex>
      </DiffModal.RightSide>
    </DiffModal>
  );
};
